<div class="upsell-guarantee py-10 px-4">
  <div class="upsell-guarantee__container text-center rounded-2xl bg-hartfelt-tan2 mx-auto py-10 px-4 desktop:p-10">
    <div class="upsell-guarantee__content max-w-2xl mx-auto">
      <img class="w-3xs mx-auto" src="{{ upsellGuarantee_mbgImg }}" alt="Upsell Guarantee Background">
      <div class="" [innerHTML]="upsellGuarantee_text"></div>

      <upsell-cta 
        [buttonYesText]="buttonYesText"
        [buttonNoText]="buttonNoText"
        (eventEmitter)="nextPage($event)">
      </upsell-cta>
    </div>
  </div>
</div>
